import Vue from "vue";

import moedaComponent from "@/components/child/form/moeda.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import clienteCreditoService from "@/services/clienteCreditoService";
import "../crud.scss";

@Component({
    components: {
        moedaComponent,
        shortcutComponent,
    },
})
export default class CreditoComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;

    credito = 0;

    public async load(clienteId: number) {
        this.credito = await clienteCreditoService.getSaldoDevedorByClienteId(clienteId);

        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = this.$t("__.Crud.cliente.credito_vue_html.titulo").toString();
        this.shortcutComponent.show();
    }
}
